import { render, staticRenderFns } from "./field-notes-section.vue?vue&type=template&id=e8d0fb1e&scoped=true&"
import script from "./field-notes-section.vue?vue&type=script&lang=js&"
export * from "./field-notes-section.vue?vue&type=script&lang=js&"
import style0 from "./field-notes-section.vue?vue&type=style&index=0&id=e8d0fb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d0fb1e",
  null
  
)

export default component.exports